import { render, staticRenderFns } from "./widget-homepage.vue?vue&type=template&id=4f272ae8&scoped=true&"
import script from "./widget-homepage.vue?vue&type=script&lang=js&"
export * from "./widget-homepage.vue?vue&type=script&lang=js&"
import style0 from "./widget-homepage.vue?vue&type=style&index=0&id=4f272ae8&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f272ae8",
  null
  
)

export default component.exports